//Legend.tsx ==============================================================
import "../Util/Prototypes";

import * as Default from "../Default";
import * as DrawerMenu from "../Menus/DrawerMenu";
import * as MainMap from "../MainMap";
import * as Settings from "../Settings";
import * as WidgetHeading from "../Widgets/WidgetHeading";

import { Paper } from "@mui/material";

import React from "react";

const toolName: string = "Legend";
const toolDiv: string = "Legend_div";
let legendWidget: __esri.Legend;

//Get legend layer setting by name.
export function getLegendLayerSetting(mapServiceID: string) {
   for (const rec of Settings.legendLayers) {
      if (rec.mapServiceID.Equal(mapServiceID)) {
         return rec;
      }
   }
   return null;
}

//Hide legend sublayers in a map image service.
export function hideLegendSublayers(sublayers: __esri.Collection<__esri.Sublayer>, hideSublayers: string[]) {
   for (const sublayer of sublayers) {
      if (hideSublayers.Contains(sublayer.title) || hideSublayers.Contains(sublayer.title + "*")) {
         sublayer.legendEnabled = false;
      }

      //Process wildcards.
      if (sublayer.parent) {
         if (hideSublayers.Contains(sublayer.parent.title + "*")) {
            sublayer.legendEnabled = false;
         }
      }

      //Recursively process the child sublayers.
      if (sublayer.sublayers && sublayer.sublayers.length > 0) {
         hideLegendSublayers(sublayer.sublayers, hideSublayers);
      }
   }
}

interface iProps {
}

//Render function.
export function Render(props: iProps) {
   //Util.logMsg("Top of Legend Render");

   //Set refresh method.
   const [ignored, refresh] = React.useReducer((x: number) => x + 1, 0);

   //Component did mount.
   React.useEffect(() => {
      import("@arcgis/core/widgets/Legend").then(({ default: LegendWidget }) => {

         legendWidget = new LegendWidget({
            container: toolDiv,
            view: MainMap.activeView,
         });

      }).catch((error: Error) => {
         console.error('An error occurred while loading the Legend Widget module:', error);
      });

      //Component will unmount.
      return () => {
         legendWidget.destroy();
      };
   }, []);

   //Component did update.
   React.useEffect(() => {
   });

   function close() {
      DrawerMenu.closeTool();
   }

   const scrollDivID: string = toolName.replace(" ", "_") + "_Scroll";

   const styles: Default.iStyles = {
      heading: { backgroundColor: Settings.headingColor },
   };

   return (
      <Paper>
         <WidgetHeading.Render title={toolName} onClose={close} />

         <div id={scrollDivID} style={Default.styles.appToolDiv}>
            <div id={toolDiv}></div>
         </div>
      </Paper>
   ); //end return.

} //end function.
